import React from 'react'
import { NoTranslate } from '../no-translate/no-translate'
import { INotificationAttribution } from '../../_utils/notification-attribution'

export interface INotificationAttributionTextProps {
    /** Resolved attribution produced by {@link getNotificationAttribution}. */
    attribution: INotificationAttribution
    /** Optional class applied to the wrapping element. */
    className?: string
    /** Wrapping element tag. Defaults to `span`. */
    as?: 'span' | 'div'
}

/**
 * Renders a notification's full, self-contained attribution label so every
 * surface presents identical, unambiguous text:
 *   - resolved feed   → `Created by Feed: {name}`
 *   - unresolved feed → `Created from Feed`
 *   - creator         → `Created by {name}`
 *
 * The static prefix stays translatable while the dynamic name (feed/creator)
 * is wrapped in {@link NoTranslate} so proper nouns are never machine
 * translated. `title` always carries the exact full text so the accessible
 * label remains complete even when the visible text is truncated.
 */
export const NotificationAttributionText: React.FC<INotificationAttributionTextProps> = ({
    attribution,
    className,
    as = 'span',
}) => {
    const Tag = as
    return (
        <Tag className={className} title={attribution.text}>
            {attribution.prefix}
            {attribution.value !== undefined && <NoTranslate>{attribution.value}</NoTranslate>}
        </Tag>
    )
}

NotificationAttributionText.displayName = 'NotificationAttributionText'
